'use strict';

var _require = require('./Component'),
    DebounceInput = _require.DebounceInput;

DebounceInput.DebounceInput = DebounceInput;

module.exports = DebounceInput;


//////////////////
// WEBPACK FOOTER
// ./~/react-debounce-input/lib/index.js
// module id = 662
// module chunks = 0